import { buildGoalsOverviewFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useGoalsOverviewFilterDocument = () => {
  const user = useUser();
  return useMemo(
    () => buildGoalsOverviewFilterDocument(user?.settings),
    [user?.settings],
  );
};
